import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: false,
  errorPresets: false,
  errorMessage: "",
  loading: false,
  loadingPresets: false,
  successRestrict: false,
  data: [],
  details: {},
  presets: [],
  presetsDetails: {},
  customers: [],
  services: [],
};

const categoriesReducer = createSlice({
  name: "categories",
  initialState,
  reducers: {
    loadingCategories(state) {
      state.loading = true;
      // state.data = [];
      state.error = false;
    },

    loadingPresets(state) {
      state.loadingPresets = true;
      // state.presets = [];
      state.errorPresets = false;
    },
    // loadingCategoriesRestrict(state) {
    //   state.loadingRestrict = true;
    //   state.successRestrict = false;
    //   state.error = false;
    // },
    // loadingCategoriesDetails(state) {
    //   state.loading = true;
    //   state.details = {};
    //   state.error = false;
    // },
    // successCategoriesDetails(state, action) {
    //   state.loading = false;
    //   state.details = action.payload;
    //   state.error = false;
    // },
    // failedCategoriesDetails(state, action) {
    //   state.loading = false;
    //   state.details = [];
    //   state.error = true;
    // },
    // loadingCategoriesServices(state) {
    //   state.loading = true;
    //   state.services = [];
    //   state.error = false;
    // },
    // successCategoriesServices(state, action) {
    //   state.loading = false;
    //   state.services = action.payload;
    //   state.error = false;
    // },
    // failedCategoriesService(state, action) {
    //   state.loading = false;
    //   state.services = [];
    //   state.error = true;
    // },
    // loadingCategoriesStaff(state) {
    //   state.loading = true;
    //   state.staff = [];
    //   state.error = false;
    // },
    // successCategoriesStaff(state, action) {
    //   state.loading = false;
    //   state.staff = action.payload;
    //   state.error = false;
    // },
    // failedCategoriesStaff(state, action) {
    //   state.loading = false;
    //   state.staff = [];
    //   state.error = true;
    // },
    // loadingCategoriesCustomers(state) {
    //   state.loading = true;
    //   state.customers = [];
    //   state.error = false;
    // },
    // successCategoriesCustomers(state, action) {
    //   state.loading = false;
    //   state.customers = action.payload;
    //   state.error = false;
    // },
    // failedCategoriesCustomers(state, action) {
    //   state.loading = false;
    //   state.customers = [];
    //   state.error = true;
    // },
    successCategories(state, action) {
      state.loading = false;
      state.data = action.payload;
      state.error = false;
    },
    successPresets(state, action) {
      state.loadingPresets = false;
      state.presets = action.payload;
      state.errorPresets = false;
    },
    successPresetsDetails(state, action) {
      state.loadingPresets = false;
      state.presets = action.payload.presets;
      state.presetsDetails = action.payload.presetsDetails;
      state.errorPresets = false;
    },
    // successCategoriesRestrict(state, action) {
    //   state.loadingRestrict = false;
    //   state.successRestrict = true;
    //   state.errorRestrict = false;
    // },
    failedCategories(state, action) {
      state.loading = false;
      // state.data = [];
      state.error = true;
      state.errorMessage = action.payload.message;
    },
    failedPresets(state, action) {
      state.loadingPresets = false;
      // state.presets = [];
      state.errorPresets = true;
      state.errorMessage=action.payload.message;
    },
    // failedCategoriesRestrict(state, action) {
    //   state.loadingRestrict = false;
    //   state.successRestrict = false;
    //   state.errorRestrict = true;
    // },
  },
});

export default categoriesReducer.reducer;

export const {
  loadingCategories,
  successCategories,
  failedCategories,
  loadingCategoriesRestrict,
  successCategoriesRestrict,
  failedCategoriesRestrict,
  loadingCategoriesDetails,
  successCategoriesDetails,
  failedCategoriesDetails,
  loadingCategoriesServices,
  successCategoriesServices,
  failedCategoriesService,
  loadingCategoriesStaff,
  successCategoriesStaff,
  failedCategoriesStaff,
  loadingCategoriesCustomers,
  successCategoriesCustomers,
  failedCategoriesCustomers,
  loadingPresets,
  successPresets,
  failedPresets,
  successPresetsDetails
} = categoriesReducer.actions;
